import React, { Component } from 'react'
import './index.scss'
import { SearchOutlined, DownOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Space, Tabs, Input } from 'antd'
import { Routes, Link } from 'react-router-dom'

export default class index extends Component {
  state = {
    windowswidth: 0,
    Homeitems: [],
    clicksecond: '',
    seconditems: [],
    selectWidth: 0,
    selectWidthbox: 0
  }
  setWidth = (e) => {
    this.setState({ windowswidth: e.target.innerWidth, Homeitems: this.setHomeitems(e.target.innerWidth) })
  }
  componentWillMount() {
    this.setState({ Homeitems: this.setHomeitems() })
  }
  setHomeitems = (width) => {
    const arr = [
      {
        label: <Link to="/" onMouseEnter={() => this.setState({ seconditems: [] })}></Link>,
        key: 'home',
        name: '首页',
        to: '/'
      },
      {
        label: (
          <div className="labelItem" onMouseEnter={(e) => this.setSecondItems('we', e)}>
            <Link to="/aboutus.html">关于我们</Link>
            <DownOutlined style={{ fontSize: '10px', marginLeft: '2px' }}></DownOutlined>
          </div>
        ),
        key: 'we',
        name: '关于我们',
        to: '/aboutus.html'
      },
      {
        label: (
          <div className="labelItem" onMouseEnter={(e) => this.setSecondItems('goods', e)}>
            <Link to="/product.html">产品中心</Link>
            <DownOutlined style={{ fontSize: '10px', marginLeft: '2px' }}></DownOutlined>
          </div>
        ),
        key: 'goods',
        name: '产品中心',
        to: '/product.html'
      },
      {
        label: (
          <Link to="/news.html" onMouseEnter={() => this.setState({ seconditems: [] })}>
            新闻中心
          </Link>
        ),
        key: 'news',
        name: '新闻中心',
        to: '/news.html'
      },
      {
        label: (
          <Link to="/contactus.html" onMouseEnter={() => this.setState({ seconditems: [] })}>
            联系我们
          </Link>
        ),
        key: 'relation',
        name: '联系我们',
        to: '/contactus.html'
      },
      {
        label: (
          <Link to="/cooperation.html" onMouseEnter={() => this.setState({ seconditems: [] })}>
            商务合作
          </Link>
        ),
        key: 'cooperation ',
        name: '商务合作',
        to: '/cooperation.html'
      }
    ]
    return arr
  }

  componentDidMount() {
    this.setState({ windowswidth: window.innerWidth })
    // 监听视口的变化
    window.addEventListener('resize', this.setWidth)
  }
  setSecondItems = (key, e) => {
    const left = e.target.getBoundingClientRect().left + 20
    console.log(e.target.getBoundingClientRect().left)
    console.dir(e.target)

    this.setState({ selectWidth: key == 'we' ? left - e.target.offsetWidth : left }, () => {
      const newSeconditems =
        key == 'we'
          ? [
              {
                label: '荣誉资质',
                key: 'hezuo',
                to: '/aboutus/honorary.html'
              },
              {
                label: '锐控生态',
                key: 'shengtai',
                to: '/aboutus/ecology.html'
              },
              {
                label: '科技创新',
                key: 'zhuanli',
                to: '/aboutus/idea.html'
              }
            ]
          : [
              {
                label: '硬件产品',
                key: 'hardware',
                to: '/product/hardware.html'
              },
              {
                label: '解决方案',
                key: 'software',
                to: '/product/solution.html'
              }
            ]

      this.setState({ clicksecond: '', seconditems: newSeconditems })
    })
  }
  tabberClick = (e) => {
    // if (e.key == 'we' || e.key == 'goods') {
    //   this.setSecondItems(e.key)
    //   return
    // }

    this.setState({ seconditems: [], clicksecond: '' })
  }
  twoClick = (key) => {
    this.state({ clicksecond: 'key' })
  }
  goPage = (i) => {}
  render() {
    const { Homeitems, seconditems, clicksecond } = this.state

    return (
      <div>
        {/* 一级 */}
        <div style={{ width: '100%', height: '100%', background: '#fff' }}>
          <div className="headerNav">
            <img src={require('../../image/kejilong.png')} alt="" className="logo" style={{ margin: 'auto 0' }} />
            <div className="tabber">
              <div className="tabber-navigation">
                {/* <Menu style={{ width: '18.5rem', color: '#333333' }} triggerSubMenuAction="click" mode="horizontal" items={Homeitems}></Menu> */}
                {Homeitems.map((i, index) => (
                  <Link to={i.to} key={index}>
                    <div className="tabber-navigation-item" onMouseEnter={(e) => (i.key == 'we' || i.key == 'goods' ? '' : this.setState({ seconditems: [] }))}>
                      <div className="nowrap">
                        <span onMouseEnter={(e) => (i.key == 'we' || i.key == 'goods' ? this.setSecondItems(i.key, e) : this.setState({ seconditems: [] }))}>{i.name}</span>

                        {i.key == 'we' || i.key == 'goods' ? <DownOutlined style={{ fontSize: '.285714rem', marginLeft: '0.1rem' }}></DownOutlined> : ''}
                      </div>

                      <div className="tabber-navigation-item-border"></div>
                    </div>
                  </Link>
                ))}
              </div>
              <div className="tabber-search">
                <Input type="text" placeholder="请输入关键字" bordered={false} className="tabber-search-input" />
                <SearchOutlined style={{ fontSize: '.4rem', color: '#d0d0d0', position: 'absolute', right: '.371429rem', top: '.228571rem ' }} className="tabber-search-icon" />　
              </div>
              <Link to="/longin.html" style={{ display: 'flex', alignItems: 'center' }}>
                <img src={require('../../image/user.png')} className="tabber-user" />
              </Link>
            </div>
          </div>
        </div>

        {/* 一级 */}
        {/*二级 */}

        <div className="secondLevel" onMouseLeave={() => this.setState({ seconditems: [], selectWidth: 0 })} style={{ top: `${seconditems.length > 0 ? '2.25rem' : '0'}`, paddingLeft: this.state.selectWidth + 'px' }}>
          {/* <div className="secondLevel" onMouseLeave={() => this.setState({ seconditems: [] })} style={{ top: '2.28rem', paddingRight: `${seconditems.length && seconditems[0].key == 'hardware' ? '25.5rem' : '29rem'}` }}> */}
          {seconditems.map((i, index) => (
            <div className={`secondLevel-item ${i.key == clicksecond ? 'clicksecond' : ''}`} key={index} onClick={() => this.goPage(i)}>
              <Link to={i.to} style={{ height: '.514286rem' }}>
                {i.label}
              </Link>
            </div>
          ))}
        </div>

        {/*二级 */}
        {/* 排他 */}
        {/* {seconditems.length > 0 && <div className="noneBgc" onClick={() => this.setState({ seconditems: [] })}></div>} */}

        {/* 排他 */}
      </div>
    )
  }
}
